import { Injectable } from '@angular/core';

import { OnAppInit } from '@frontend/vanilla/core';
import { PageMatrixService } from '@frontend/vanilla/features/content';

import { PromoOptinInstaStoryitemComponent } from './promo-optin-insta-storyitem.component';

@Injectable({
    providedIn: 'root',
})
export class PromoOptinInstaStoryItemBootstrapService implements OnAppInit {
    constructor(private pageMatrixService: PageMatrixService) {}

    onAppInit() {
        this.pageMatrixService.registerComponent('promooptininstastoryitem', PromoOptinInstaStoryitemComponent);
    }
}
